import Vue from 'vue';
import VueRouter from 'vue-router';

import Login from './views/Login.vue';
import Home from './views/Home.vue';

//SCTRUCTURE
import StructureType from './views/Structure/Type.vue';
import StructureTitle from './views/Structure/Title.vue';

//MANAGE ROLE
import OverviewRole from './views/ManageRole/OverviewRole.vue';
import UploadNewRole from './views/ManageRole/UploadNewRole.vue';
import AddNewRole from './views/ManageRole/AddNewRole.vue';

//MAPPING SALES REP ASSIGNMENT
import UploadMappingSalesRepAssignment from './views/MappingSalesRepAssignment/UploadMappingSalesRepAssignment.vue';
import AddMappingSalesRepAssignment from './views/MappingSalesRepAssignment/AddNewMappingSalesAssignment.vue';
import OverviewMappingSalesRepAssignment from './views/MappingSalesRepAssignment/OverviewMappingSalesRepAssignment.vue';

//MAPPING SALES ASSIGNMENT
import OverviewMappingSalesAssignment from './views/MappingSalesAssignment/OverviewMappingSalesAssignment.vue';
import UploadMappingSalesAssignment from './views/MappingSalesAssignment/UploadMappingSalesAssignment.vue';
import AddNewMappingSalesAssignment from './views/MappingSalesAssignment/AddNewMappingSalesAssignment.vue';
import EditMappingSalesAssignment from './views/MappingSalesAssignment/EditMappingSalesAssignment.vue';
import PrintQRRelasi from './views/MappingSalesAssignment/PrintQRRelasi.vue';
import PrintQRRelasiNew from "./views/MappingSalesAssignment/PrintQRRelasiNew.vue";
import OverviewGeotag from './views/MappingSalesAssignment/OverviewGeotag.vue';
import OverviewUnmappingSales from './views/MappingSalesAssignment/OverviewUnmappingSales.vue';

//TARGET
import OverviewTarget from './views/Target/OverviewTarget.vue';
import SubmitTarget from './views/Target/SubmitTarget.vue';
import UploadTarget from './views/Target/UploadTarget.vue';
import OverviewTargetBranch from './views/Target/OverviewTargetBranch.vue';
import SubmitTargetBranch from './views/Target/SubmitTargetBranch.vue';
import ApprovalTarget from './views/Target/ApprovalTarget.vue';
import ApprovalTargetCab from './views/Target/ApprovalTargetCab.vue';
import DeleteTargetCab from './views/Target/DeleteTargetCab.vue';
//FILE VIEWER
import FileViewer from './views/FileViewer/OverviewFile.vue';
import FileViewerNew from "./views/FileViewerNew/OverviewFile.vue";

//ADJUST INCENTIVE
import AdjustIncentive from './views/AdjustIncentive/AdjustIncentive.vue';
import AdjustIncentiveSummary from './views/AdjustIncentive/AdjustIncentiveSummary.vue';
import UploadIncentive from './views/AdjustIncentive/UploadIncentive.vue';
import ApprovalIncentive from './views/AdjustIncentive/ApprovalIncentive.vue';

//CALL MANAGEMENT
import UploadFixedCall from './views/CallManagement/UploadFixedCall.vue';
import OverviewFixedCall from './views/CallManagement/OverviewFixedCall.vue';
import OverviewCallRealization from './views/CallManagement/OverviewCallRealization.vue';
import UploadCalendar from './views/CallManagement/UploadCalendar.vue';
import OverviewCalendar from './views/CallManagement/OverviewCalendar.vue';
import UploadMasterCall from './views/CallManagement/UploadMasterCall.vue';
import OverviewMasterCall from './views/CallManagement/OverviewMasterCall.vue';

//BISNIS LINI PRODUCT
import UploadBisnisLiniProduct from './views/BisnisLiniProduct/UploadBisnisLiniProduct.vue';
import OverviewBisnisLiniProduct from './views/BisnisLiniProduct/OverviewBisnisLiniProduct.vue';

//Push Activity
import AddPAHeader from './views/PushActivity/AddPAHeader.vue';
import PAApproval from './views/PushActivity/ApprovalPA.vue';
import PAOverview from './views/PushActivity/PAOverview.vue';

//Push Setting
import SettingPeriod from './views/Setting/SettingPeriod.vue';
import SettingBanner from './views/Setting/SettingBanner.vue';

Vue.use(VueRouter);

const RoutesMain = [
	{
		path: '/login',
		name: 'Login',
		component: Login,
		meta: {
			title: 'Login',
		},
	},
	{
		path: '/',
		name: 'Home',
		component: Home,
		meta: {
			title: 'Home',
		},
	},
];

const RoutesStructure = [
	{
		path: '/structure/type',
		name: 'Type',
		component: StructureType,
		meta: {
			title: 'Structure Type',
		},
	},
	{
		path: '/structure/type/:typeId',
		component: StructureType,
		meta: {
			title: 'Structure Type',
		},
	},
	{
		path: '/structure/title',
		name: 'Title',
		component: StructureTitle,
		meta: {
			title: 'Structure Title',
		},
	},
	{
		path: '/structure/title/:titleId',
		component: StructureTitle,
		meta: {
			title: 'Structure Title',
		},
	},
];

const RoutesManageRole = [
	{
		path: '/manage-role/overview',
		name: 'RoleOverview',
		component: OverviewRole,
		meta: {
			title: 'Role Overview',
		},
	},
	{
		path: '/manage-role/upload',
		name: 'UploadNewRole',
		component: UploadNewRole,
		meta: {
			title: 'Upload New Role',
		},
	},
	{
		path: '/manage-role/new',
		name: 'AddNewRole',
		component: AddNewRole,
		meta: {
			title: 'Add New Role',
		},
	},
	{
		path: '/manage-role/new/:roleMapID',
		name: 'EditStructureRole',
		component: AddNewRole,
		meta: {
			title: 'Edit Structure Role',
		},
	},
];

const RoutesMappingSalesRepAssignment = [
	// {
	// 	path: '/mapping-sales-rep/upload',
	// 	name: 'MappingSalesRepAssignmentUpload',
	// 	component: UploadMappingSalesRepAssignment,
	// 	meta: {
	// 		title: 'Mapping Sales Rep',
	// 	},
	// },
	// {
	// 	path: '/mapping-sales-rep/new',
	// 	name: 'MappingSalesRepAssignmentAdd',
	// 	component: AddMappingSalesRepAssignment,
	// 	meta: {
	// 		title: 'Mapping Sales Rep',
	// 	},
	// },
	{
		path: '/mapping-sales-rep/overview',
		name: 'MappingSalesRepAssignmentOverview',
		component: OverviewMappingSalesRepAssignment,
		meta: {
			title: 'Mapping Sales Rep',
		},
	},
]

const RoutesMappingSalesAssignment = [
	{
		path: '/mapping-sales-assignment/overview',
		name: 'MappingSalesAssignmentOverview',
		component: OverviewMappingSalesAssignment,
		meta: {
			title: 'Overview Mapping Sales Assignment',
		},
	},
	{
		path: '/mapping-sales-assignment/upload',
		name: 'UploadMappingSalesAssignment',
		component: UploadMappingSalesAssignment,
		meta: {
			title: 'Upload Mapping Sales Assignment',
		},
	},
	{
		path: '/mapping-sales-assignment/new',
		name: 'AddNewMappingSalesAssignment',
		component: AddNewMappingSalesAssignment,
		meta: {
			title: 'Add New Mapping Sales Assignment',
		},
	},
	{
		path: '/mapping-sales-assignment/edit/:salesrepMapId',
		name: 'EditMappingSalesAssignment',
		component: EditMappingSalesAssignment,
		meta: {
			title: 'Edit Mapping Sales Assignment',
		},
	},
  {
    path: '/mapping-sales-assignment/printqrrelasi',
    name: 'Print QR Relasi',
    component: PrintQRRelasi,
    meta: {
      title: 'Print QR Relasi',
    },
  },
   {
    path: "/mapping-sales-assignment/printqrrelasinew",
    name: "Print QR Relasi New",
    component: PrintQRRelasiNew,
    meta: {
      title: "Print QR Relasi New",
    },
  },
  {
	path: '/mapping-sales-assignment/overviewgeotag',
	name: 'Overview Geotag',
	component: OverviewGeotag,
	meta: {
		title: 'Overview Geotag',
	},
  },
  {
	path: '/mapping-sales-assignment/overviewunmappingsales',
	name: 'Overview Unmapping Sales',
	component: OverviewUnmappingSales,
	meta: {
		title: 'Overview Unmapping Sales',
	},
  },
];

const RoutesTarget = [
	{
		path: '/target/overview',
		name: 'OverviewTarget',
		component: OverviewTarget,
		meta: {
			title: 'Overview Target',
		},
	},
	{
		path: '/target/submit',
		name: 'SubmitTarget',
		component: SubmitTarget,
		meta: {
			title: 'Submit Target',
		},
	},
	{
		path: '/target/upload',
		name: 'UploadTarget',
		component: UploadTarget,
		meta: {
			title: 'Upload Target',
		},
	},
	{
		path: '/target/overviewbranch',
		name: 'OverviewTargetBranch',
		component: OverviewTargetBranch,
		meta: {
			title: 'Overview Target Branch',
		},
	},
	{
		path: '/target/submitbranch',
		name: 'SubmitTargetBranch',
		component: SubmitTargetBranch,
		meta: {
			title: 'Submit Target Branch',
		},
	},
	{
		path: '/target/approvaltarget',
		name: 'ApprovalTarget',
		component: ApprovalTarget,
		meta: {
			title: 'Approval Target',
		},
	},
	{
		path: '/target/approvaltargetcab',
		name: 'ApprovalTargetCab',
		component: ApprovalTargetCab,
		meta: {
			title: 'Approval Target Cabang',
		},
	},
	{
		path: '/target/deletetargetcab',
		name: 'DeleteTargetCab',
		component: DeleteTargetCab,
		meta: {
			title: 'Delete Target Branch',
		},
	},
	
	
];

const RoutesFileViewer = [
	{
		path: '/crc/overview',
		name: 'OverviewFile',
		component: FileViewer,
		meta: {
			title: 'Overview File',
		},
	},
	 {
    path: "/crc/overview-display-src",
    name: "OverviewFileNew",
    component: FileViewerNew,
    meta: {
      title: "Overview File New",
    },
  },
];

const RoutesBisnisLiniProduct = [
	{
		path: '/mapping-sublini-product/upload',
		name: 'Upload',
		component: UploadBisnisLiniProduct,
		meta: {
			title: 'Upload Bisnis Lini Product',
		},
	},
	{
		path: '/mapping-sublini-product/overview',
		name: 'Overview',
		component: OverviewBisnisLiniProduct,
		meta: {
			title: 'Overview Bisnis Lini Product',
		},
	}
];


const RoutesAdjustIncentive = [
	{
		path: '/adjust-incentive/upload',
		name: 'UploadIncentive',
		component: UploadIncentive,
		meta: {
			title: 'UploadIncentive',
		},
	},
	{
		path: '/adjust-incentive/new',
		name: 'AdjustIncentive',
		component: AdjustIncentive,
		meta: {
			title: 'Adjust Incentive',
		},
	},
	{
		path: '/adjust-incentive/summary',
		name: 'AdjustIncentiveSummary',
		component: AdjustIncentiveSummary,
		meta: {
			title: 'Adjust Incentive Summary',
		},
	},
	{
		path: '/adjust-incentive/approval',
		name: 'ApprovalIncentive',
		component: ApprovalIncentive,
		meta: {
			title: 'Adjust Incentive Approval',
		},
	}
];

const RoutesCallManagement = [
	{
		path: '/call-management/uploadfixedcall',
		name: 'UploadFixedCall',
		component: UploadFixedCall,
		meta: {
			title: 'Upload Fixed Call',
		},
	},
	{
		path: '/call-management/overviewfixedcall',
		name: 'OverviewFixedCall',
		component: OverviewFixedCall,
		meta: {
			title: 'Overview Fixed Call',
		},
	},
	{
		path: '/call-management/overviewrealization',
		name: 'OverviewCallRealization',
		component: OverviewCallRealization,
		meta: {
			title: 'Overview Call Realization',
		},
	},	
	{
		path: '/call-management/uploadCalendar',
		name: 'UploadCalendar',
		component: UploadCalendar,
		meta: {
			title: 'Upload Calendar',
		},
	},	
	{
		path: '/call-management/overviewCalendar',
		name: 'OverviewCalendar',
		component: OverviewCalendar,
		meta: {
			title: 'Overview Calendar',
		},
	},
	{
		path: '/call-management/uploadmastercall',
		name: 'UploadMasterCall',
		component: UploadMasterCall,
		meta: {
			title: 'Upload Master Call Plan',
		},
	},		
	{
		path: '/call-management/overviewmastercall',
		name: 'OverviewMasterCall',
		component: OverviewMasterCall,
		meta: {
			title: 'Overview Master Call',
		},
	},
];

const RoutesPA = [
	{
		path: '/pushactivity/addpaheader',
		name: 'AddPAHeader',
		component: AddPAHeader,
		meta: {
			title: 'Add PA Header',
		},
	},
	{
		path: '/pushactivity/paapproval',
		name: 'PAApproval',
		component: PAApproval,
		meta: {
			title: 'PA Approval',
		},
	},
	{
		path: '/pushactivity/paoverview',
		name: 'PAOverview',
		component: PAOverview,
		meta: {
			title: 'PA Overview',
		},
	}
];

const RoutesSetting = [
	{
		path: '/setting/settingperiod',
		name: 'SettingPeriod',
		component: SettingPeriod,
		meta: {
			title: 'Setting Period',
		},
	},
	{
		path: '/setting/settingslide',
		name: 'SettingBanner',
		component: SettingBanner,
		meta: {
			title: 'Promotion Setting',
		},
	},
];


const routes = [
	...RoutesMain,
	...RoutesStructure,
	...RoutesManageRole,
	...RoutesMappingSalesRepAssignment,
	...RoutesMappingSalesAssignment,
	...RoutesTarget,
	...RoutesAdjustIncentive,
	...RoutesCallManagement,
	...RoutesFileViewer,
	...RoutesBisnisLiniProduct,
	...RoutesPA,
	...RoutesSetting
];

const router = new VueRouter({
	mode: 'history',
	routes,
});

router.beforeEach((to, from, next) => {
	let isAuthenticated = localStorage.getItem('userData') != null;
	switch (to.name) {
		case 'Login': {
			if (isAuthenticated) {
				next({ name: 'Home' });
			} else {
				next();
			}
			break;
		}
		default: {
			if (isAuthenticated == true) {
				next();
			} else {
				next({ name: 'Login' });
			}
		}
	}
});

router.afterEach((to) => {
	if (to.meta && to.meta.title) {
		document.title = to.meta.title + ' | iMAPS - Integrated Mapping & Adjustment Portal for Sales';
	}
});


export default router;
